export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Norway-0610f8e9418dd6dcc1231d61699e5450.mp3";